import { useTranslation } from "react-i18next";
import { LoadingPanel } from "~/components/panels";
import { useSession } from "~/contexts/auth-context";
import { useProduct } from "~/contexts/product-context";
import { useProductSemanticData } from "./hooks/use-product-semantic-data";
import { SummaryTabView } from "./summary-tab-view";

interface SummaryTabContentProps {
  organisationId: string;
  productId: string;
  workId?: string | null;
  productTitle: string;
}

const SummaryTabContent = ({
  organisationId,
  productId,
  workId,
  productTitle,
}: SummaryTabContentProps) => {
  const { semanticData, loading, error } = useProductSemanticData(
    productId,
    organisationId,
    workId,
  );

  return (
    <SummaryTabView
      productTitle={productTitle}
      semanticData={semanticData}
      loading={loading}
      error={error}
    />
  );
};

export const SummaryTab = () => {
  const { t } = useTranslation(["productDetails"]);
  const { product } = useProduct();
  const { organisation } = useSession();

  return (
    <div className="mt-3 h-[calc(100%_-_0.75rem)] [&>*]:h-full">
      {product ? (
        <SummaryTabContent
          organisationId={organisation.id}
          productId={product.id}
          workId={product.workId}
          productTitle={product.title ?? ""}
        />
      ) : (
        <LoadingPanel loadingText={t("productDetails:summary.loading")} />
      )}
    </div>
  );
};
